import axios from "axios";
import { mapDataToFormData } from "../helpers/global";
export default class AddonDownloader {
    constructor(slug, network_admin, nonce) {
        this.slug = slug;
        this.network_admin = network_admin;
        this.nonce = nonce;
    }
    download() {
        return axios.post(ajaxurl, mapDataToFormData({
            action: 'acp-ajax-install-addon',
            plugin_name: this.slug,
            network_wide: this.network_admin ? 1 : 0,
            _ajax_nonce: this.nonce
        }));
    }
}
